import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
 restrictedIpAddress = ['61.2.100.195','59.90.205.116','59.90.205.115','202.43.122.48','103.162.200.76'];
 
 private heightBehavior = new BehaviorSubject<number>(20);
  height$ = this.heightBehavior.asObservable();
  private _Subject = new BehaviorSubject<boolean>(false);
  public _observer$:Observable<boolean> = this._Subject.asObservable();
  subject = new BehaviorSubject('');
  url = environment.apiUrl;
  
  constructor(
    private http: HttpClient,
  ) { }

  // login validation
  userLogin(user: any) {
    return this.http.post<any>(`${this.url}${environment.login}`, {login:user});
  }

  //otp sending
  loginOTP(user: any) {
    return this.http.post<any>(`${this.url}${environment.loginOTP}`, user);
  }
//otp verification
loginOTPVerification(user: any) {
  return this.http.post<any>(`${this.url}${environment.loginOTPVerify}`, user);
}

//validate otp verification
validateOTP(user: any) {
  return this.http.post<any>(`${this.url}${environment.validOTP}`, user);
}
forgotPasswordOTPVerify(user: any) {
  return this.http.post<any>(`${this.url}${environment.validOTP}`, user);
}

//forgot password
forgotPassword(user: any) {
  return this.http.post<any>(`${this.url}${environment.forgotpassword}`, user);
}

//forgot password
roleList(user: any) {
  return this.http.post<any>(`${this.url}${environment.roleList}`, user);
}

//change password
changePassword(user: any) {
  return this.http.post<any>(`${this.url}${environment.updatePassword}`, user);
}

//change password
roleListByOrganisation(user: any) {
  return this.http.post<any>(`${this.url}${environment.rolesListByOrganisation}`, user);
}

getIPAddress() {
  return this.http.get('https://ipv4.myexternalip.com/json');
}


//Data Entry Operator Role Api Method's


getDivisionsList(body: any) {
  return this.http.post<any>(`${this.url}${environment.getDivisionsList}`, body);
}
getCropYearsList(body: any) {
  return this.http.post<any>(`${this.url}${environment.getCropYearsList}`, body);
}

getChallansList(body: any) {
  return this.http.post<any>(`${this.url}${environment.getChallansList}`, body);
}
getUploadedChallans(body: any) {
  return this.http.post<any>(`${this.url}${environment.getUploadedChallans}`, body);
}
addContainerManual(body: any) {
  return this.http.post<any>(`${this.url}${environment.addContainerManual}`, body);
}

generateUniqueChallanNo(body: any) {
  return this.http.post<any>(`${this.url}${environment.generateUniqueChallanNo}`, body);
}

fileUpload(body: any) {
  return this.http.post<any>(`${this.url}${environment.fileUpload}`, body);
}
addContainerAutomatic(body: any) {
  return this.http.post<any>(`${this.url}${environment.addContainerAutomatic}`, body);
}

getChallanDetailsByChallanId(body: any) {
  return this.http.post<any>(`${this.url}${environment.getChallanDetailsByChallanId}`, body);
}

updateChallanStatusToSumitted(body: any) {
  return this.http.post<any>(`${this.url}${environment.updateChallanStatusToSumitted}`, body);
}
updateContainerNET_GROSS_WEIGHT(body: any) {
  return this.http.post<any>(`${this.url}${environment.updateContainerNET_GROSS_WEIGHT}`, body);
}
getVerifiedPendingList(body: any) {
  return this.http.post<any>(`${this.url}${environment.getVerifiedPendingList}`, body);
}
updateVerifiedStatus(body: any) {
  return this.http.post<any>(`${this.url}${environment.updateVerifiedStatus}`, body);
}

GEN_QR_CODEFORVERIFIER(body: any) {
  return this.http.post<any>(`${this.url}${environment.GEN_QR_CODEFORVERIFIER}`, body);
}


getValidateList(body: any) {
  return this.http.post<any>(`${this.url}${environment.getValidateList}`, body);
}

containerWiseLogs(body: any) {
  return this.http.post<any>(`${this.url}${environment.containerWiseLogs}`, body);
}

updateValidateStatus(body: any) {
  return this.http.post<any>(`${this.url}${environment.updateValidateStatus}`, body);
}

getReceiveContainerList(body: any) {
  return this.http.post<any>(`${this.url}${environment.getReceiveContainerList}`, body);
}
updateLocationName(body: any) {
  return this.http.post<any>(`${this.url}${environment.updateLocationName}`, body);
}
updateReceiveBackStatus(body: any) {
  return this.http.post<any>(`${this.url}${environment.updateReceiveBackStatus}`, body);
}

getReceiverCountList(body: any) {
  return this.http.post<any>(`${this.url}${environment.getReceiverCountList}`, body);
}

receivedContainerSelected(body: any) {
  return this.http.post<any>(`${this.url}${environment.receivedContainerSelected}`, body);
}

getSampleAssistantList(body: any) {
  return this.http.post<any>(`${this.url}${environment.getSampleAssistantList}`, body);
}

assigningSampleAssitant(body: any) {
  return this.http.post<any>(`${this.url}${environment.assigningSampleAssitant}`, body);
}


getAllotedList(body: any) {
  return this.http.post<any>(`${this.url}${environment.getAllotedList}`, body);
}

getSamplesDetails(body: any) {
  return this.http.post<any>(`${this.url}${environment.getSamplesDetails}`, body);
}
decryptQRCode(body: any) {
  return this.http.post<any>(`${this.url}${environment.decryptQRCode}`, body);
}
createSampleWithQRCode(body: any) {
  return this.http.post<any>(`${this.url}${environment.createSampleWithQRCode}`, body);
}
sampleDrawnPush(body: any) {
  return this.http.post<any>(`${this.url}${environment.sampleDrawnPush}`, body);
}

updateExistContainer(body: any) {
  return this.http.post<any>(`${this.url}${environment.updateExistContainer}`, body);
}
sendSamplesToLab(body: any) {
  return this.http.post<any>(`${this.url}${environment.sendSamplesToLab}`, body);
}
getLabReceiverDetails(body: any) {
  return this.http.post<any>(`${this.url}${environment.getLabReceiverDetails}`, body);
}
decryptQRCodeForLabReceiver(body: any) {
  return this.http.post<any>(`${this.url}${environment.decryptQRCodeForLabReceiver}`, body);
}
updateReceiveForTesting(body: any) {
  return this.http.post<any>(`${this.url}${environment.updateReceiveForTesting}`, body);
}
editTray(editTray){
  return this.http.post<any>(`${this.url}${environment.editTray}`, editTray); 
}
getTrayList(getTrayList){
  return this.http.post<any>(`${this.url}${environment.getTrayList}`,getTrayList );
}

sendToLabAdmin(sendToLabAdmin){
  return this.http.post<any>(`${this.url}${environment.sendToLabAdmin}`,sendToLabAdmin );
}

getReceivedForTesting(getReceivedForTesting){
  return this.http.post<any>(`${this.url}${environment.getReceivedForTesting}`,getReceivedForTesting );
}

labAnalystList(labAnalystList){
  return this.http.post<any>(`${this.url}${environment.labAnalystList}`,labAnalystList );
}
assignLabAnalyst(assignLabAnalyst){
  return this.http.post<any>(`${this.url}${environment.assignLabAnalyst}`,assignLabAnalyst );
}
reAssignLabAnalyst(assignLabAnalyst){
  return this.http.post<any>(`${this.url}${environment.reAssignLabAnalyst}`,assignLabAnalyst );
}
updateConsistency(updateConsistency){
  return this.http.post<any>(`${this.url}${environment.updateConsistency}`,updateConsistency );
}
resultsUpdated(updateConsistency){
  return this.http.post<any>(`${this.url}${environment.updateConsistency}`,updateConsistency );
}
trayIdList(trayIdList){
  return this.http.post<any>(`${this.url}${environment.trayIdList}`,trayIdList );
}
trayIdWiseDetails(trayIdWiseDetails){
  return this.http.post<any>(`${this.url}${environment.trayIdWiseDetails}`,trayIdWiseDetails );
}
generateHashCode(hashObj){
  return this.http.post<any>(`${environment.hashUrl}`+':444/api',hashObj );
}
 
downLoadFile(fileObj){
  return this.http.post<any>(`${environment.hashUrl}`+':444/api/download',fileObj );
}

printResults(printResults){
  return this.http.post<any>(`${this.url}${environment.printResults}`,printResults );
}
setUserDeactive(usersObj){
  return this.http.post<any>(`${this.url}${environment.setUserDeactive}`, usersObj);

}
getDivisionUnit(getDivisionUnit){
  return this.http.post<any>(`${this.url}${environment.getDivisionUnit}`, getDivisionUnit);

}
getSampleLog(sampleLog){
  return this.http.post<any>(`${this.url}${environment.sampledPrintLog}`, sampleLog);

}
printSample(sampleLog){
  return this.http.post<any>(`${this.url}${environment.printSample}`, sampleLog);

}


//create user
createUser(user: any) {
  return this.http.post<any>(`${this.url}${environment.createUser}`, user);
}

//create container
createContainer(user: any) {
  return this.http.post<any>(`${this.url}${environment.createContainer}`, user);
}

//challan list container by organisation
challanListByOrganisation(user: any) {
  return this.http.post<any>(`${this.url}${environment.selectContainerList}`, user);
}

//challan list division_challan_no
challanListByChallan(user: any) {
  return this.http.post<any>(`${this.url}${environment.selectByContainer}`, user);
}

//challan no
challanByChallanNo(user: any) {
  return this.http.post<any>(`${this.url}${environment.selectByContainer}`, user);
}
//challan no
challanByContainerNo(user: any) {
  return this.http.post<any>(`${this.url}${environment.selectByContainerNumber}`, user);
}
listDivisionByOrganisationId(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.listDivisionByOrganisationId}`, orgObj);
}
listChallanByOrganisationId(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.listChallanByOrganisationId}`, orgObj);
}
//container status update
updateContainerStatus(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.updateContainerStatus}`, orgObj);
}

//container count update
updateContainerCount(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.updateNoContainers}`, orgObj);
}
updateInCharge(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.updateInCharge}`, orgObj);
}

updateContainwise(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.updateContainwise}`, orgObj);
}

updateRemarks(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.updateRemarks}`, orgObj);
}
editContainer(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.editContainer}`, orgObj);
}
deleteContainer(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.deleteContainer}`, orgObj);
}
setHeight(value: number) {
  this.heightBehavior.next(value);
}
updateContainerNetGrossWt(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.updateNetGrossweight}`, orgObj);
}

checkIpAddress(){
  return this.http.get<any>(`${environment.checkIpAddress}`);

}
IPWhitelist(ipObject){
  return this.http.post<any>(`${this.url}${environment.IPWhitelist}`, ipObject);

}
getVerifyStatus(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.getVerifyStatus}`, orgObj);
}


ExcelCreateContainer(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.ExcelCreateContainer}`, orgObj);
}

getContainerDetails(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.getContainerDetails}`, orgObj);
}


getFactoryContainerNo(orgObj:any){
  return this.http.post<any>(`${this.url}${environment.getFactoryContainerNo}`, orgObj);
}
SAMPLING_GET_CHALLANS(userObj){
  return this.http.post<any>(`${this.url}${environment.SAMPLING_GET_CHALLANS}`, userObj);
}
getRandomChallans(challanObj){
  return this.http.post<any>(`${this.url}${environment.getRandomChallans}`, challanObj);
}
saveSelectedSamplingChallans(challanObj){
  return this.http.post<any>(`${this.url}${environment.saveSelectedSamplingChallans}`, challanObj);
}
//fetching sample list
issueContainersForSampling(samplingObj){
  return this.http.post<any>(`${this.url}${environment.issueContainersForSampling}`, samplingObj);
}
sampleAssistantList(samplingObj){
  return this.http.post<any>(`${this.url}${environment.sampleAssistantList}`, samplingObj);
}
viewIssuedForSampling(sampleViewObj){
  return this.http.post<any>(`${this.url}${environment.viewIssuedForSampling}`, sampleViewObj);
}
createSample(createSampleObj){
  return this.http.post<any>(`${this.url}${environment.createSample}`, createSampleObj);
}
sentToLabs(sentToLabsObj){
  return this.http.post<any>(`${this.url}${environment.sentToLabs}`, sentToLabsObj);
}
genQRsampleId(genQRsampleObject){
    return this.http.post<any>(`${this.url}${environment.genQRsampleId}`, genQRsampleObject);
  }
  SAMPLING_UPDATE_RECEIVE_IN_PROGRESS(trayObject){
    return this.http.post<any>(`${this.url}${environment.SAMPLING_UPDATE_RECEIVE_IN_PROGRESS}`, trayObject);
  }
  SAMPLING_UPDATE_RECEIVED_TESTING(trayObject){
    return this.http.post<any>(`${this.url}${environment.SAMPLING_UPDATE_RECEIVED_TESTING}`, trayObject);
  }
  samplesSentList(trayObject){
    return this.http.post<any>(`${this.url}${environment.samplesSentList}`, trayObject);
  }
  GET_LAB_ANYS_ALLOTED(allocatedData){
    return this.http.post<any>(`${this.url}${environment.GET_LAB_ANYS_ALLOTED}`, allocatedData);
  }
  SMPL_TESTING_LIST(testingListObject){
    return this.http.post<any>(`${this.url}${environment.SMPL_TESTING_LIST}`, testingListObject);
  }
  updateReceiveSampleStatus(sampleObject){
    return this.http.post<any>(`${this.url}${environment.updateReceiveSampleStatus}`, sampleObject);
  }
  updateResultUploaded(sampleObject){
    return this.http.post<any>(`${this.url}${environment.updateResultUploaded}`, sampleObject);
  }
  labAceUpdateResultUploaded(sampleObject){
    return this.http.post<any>(`${this.url}${environment.labAceUpdateResultUploaded}`, sampleObject);
  }
  bulkupdateResultUploaded(sampleObject){
    return this.http.post<any>(`${this.url}${environment.bulkupdateResultUploaded}`, sampleObject);
  }
  listDivisionByOrganisation(orgObject){
    return this.http.post<any>(`${this.url}${environment.listDivisionByOrganisation}`, orgObject);
  }
  DecryptQR(decryptQR){
    return this.http.post<any>(`${this.url}${environment.DecryptQR}`, decryptQR);
  }
  deleteTray(trayObject){

    return this.http.post<any>(`${this.url}${environment.deleteTray}`, trayObject);

  }
  dashboardSummary(dashboardObject){
    return this.http.post<any>(`${this.url}${environment.dashboardSummary}`, dashboardObject);

  }
  changeReceiveBack(receiveObj){
    return this.http.post<any>(`${this.url}${environment.changeReceiveBack}`, receiveObj);

    
  }
  
  bulkupload_update(batchData){
    return this.http.post<any>(`${this.url}${environment.bulkupload_update}`, batchData);

    
  }
  getChallanEnquiryData(challanData){
    return this.http.post<any>(`${this.url}${environment.getChallanEnquiryData}`, challanData);

    
  }
  getDaySummeryData(summeryData){
    return this.http.post<any>(`${this.url}${environment.getDaySummeryData}`, summeryData);

    
  }
  getCropYearSummuryData(summeryData){
    return this.http.post<any>(`${this.url}${environment.getCropYearSummuryData}`, summeryData);    
  }
  getTraySequenceNumber(){
    const userId = localStorage.getItem("uuid");
  const data=  {
    // "_methodName": "34",
    "_methodName": "51",
    "_userId": userId
    }
    return this.http.post<any>(`${this.url}${environment.getTraySequenceNumber}`, data);
  }
  userLogs(logsData){
    return this.http.post<any>(`${this.url}${environment.userLogs}`, logsData);

  }
  getUserList(usersObj){
    return this.http.post<any>(`${this.url}${environment.getUserList}`, usersObj);

  }
  
  sentToImportIncharge(challanObj){
    return this.http.post<any>(`${this.url}${environment.sentToImportIncharge}`, challanObj);

  }
  masterDataDivisionsList(divisionObj){
    return this.http.post<any>(`${this.url}${environment.masterDataDivisionsList}`, divisionObj);

  }
  addDivision(addDivisionObj){
    return this.http.post<any>(`${this.url}${environment.addDivision}`, addDivisionObj);

  }
  getCropYearList(cropYearObj){
    return this.http.post<any>(`${this.url}${environment.getCropYearList}`, cropYearObj);

  }
  labreceiverStatus(labreceiverObj){
    return this.http.post<any>(`${this.url}${environment.labreceiverStatus}`, labreceiverObj);

  }
  misFilter(misFilterObj){
    return this.http.post<any>(`${this.url}${environment.misFilter}`, misFilterObj);

  }
  misReportOne(misReportOneObj){
    return this.http.post<any>(`${this.url}${environment.misReportOne}`, misReportOneObj);
  }
  getFile(fileObj){
    return this.http.post<any>(`${this.url}${environment.getFile}`, fileObj);
  }
  getFactoryContainerList(facObj){
    return this.http.post<any>(`${this.url}${environment.getFactoryContainerList}`, facObj);
  }
}
// {
//   "_fContainerNos":[11,13],
//   "_userId": "2" 
// } s

